import type { ValueOf } from './util/typeUtils';

export const MUTATION_KEYS = {
    ARCHIVE_CHAT: 'archiveChat',
    CANCEL_CONSORS_SUBSCRIPTION: 'cancelConsorsSubscription',
};

export const OFFER_MANAGEMENT_MORE_ACTIONS_MENU_ALERTS = {
    NEW_CONSORS_NOTES: 'New Consors notes',
};

export const DOT_COLORS = {
    BLUE: 'blue',
    GREEN: 'green',
    GREY: 'grey',
    RED: 'red',
    WHITE: 'white',
    YELLOW: 'yellow',
} as const;

export type DOT_COLOR = ValueOf<typeof DOT_COLORS>;

export const EMPTY_PLACEHOLDER = '–';
